import ReactDOM from 'react-dom';
import classes from './Modal.module.scss';
interface ModalProps {
  visible: boolean;
  toggle: () => void;
  children: any;
}

const Modal = ({ visible, toggle, children }: ModalProps) =>
  visible
    ? ReactDOM.createPortal(
        <div className={classes.modal}>
          <div className={classes.contentWrapper}>{children}</div>
        </div>,
        document.body
      )
    : null;

export default Modal;
